import { Box, Modal, Grid, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import ReviewContext from 'src/store/review-page-context';
import StepperContext from 'src/store/stepper-context';
import { colors } from 'src/styles/theme';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  minWidth: '300px',
};

const ItemizeFilingModal = () => {
  const { itemizeModal } = useContext(ReviewContext);
  const { setStepNo } = useContext(StepperContext);
  const { itemizeModalController } = itemizeModal;

  return (
    <>
      <Modal open={itemizeModalController.open} onClose={itemizeModalController.closeModal}>
        <Box sx={style}>
          <Grid container sx={{ justifyContent: 'center', mb: '1rem' }}>
            <Grid item>
              <Typography component="h2">To qualify, you must have an itemized filing</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
            <Grid item>
              <Button type="submit" variant="outlined" onClick={itemizeModalController.closeModal}>
                Do not itemize
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                onClick={() => {
                  setStepNo(0);
                }}
              >
                Itemize
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ItemizeFilingModal;
